import React from 'react';
import { createPortal } from 'react-dom';
import FormularioCliente from '../../Formularios/FormularioCliente';

const ModalCliente = ({ show, client, onClose, onSaveSuccess }) => {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1100] flex items-center justify-center p-4 backdrop-blur-sm transition-opacity text-left font-['Inter']">
      {/* Cambiamos h-auto por h-full para que el max-h-[90vh] sea efectivo 
          y los contenedores internos flex-grow puedan calcular su scroll correctamente.
      */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-full max-h-[90vh] flex flex-col overflow-hidden border border-gray-100 animate-fade-in">
        
        {/* Header Fijo (Solo en ModalCliente) */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-blue-50 shrink-0">
          <h3 className="text-xl font-bold text-gray-900">
            {client ? 'Editar Asegurado' : 'Nuevo Asegurado'}
          </h3>
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 rounded-full hover:bg-white/80"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Contenedor del Formulario - Ocupa el espacio restante y permite el scroll interno del hijo */}
        <div className="flex-grow overflow-hidden flex flex-col">
          <FormularioCliente 
            initialData={client} 
            onCancel={onClose}
            onSaveSuccess={onSaveSuccess} 
          />
        </div>
      </div>

      <style>{`
        .animate-fade-in { animation: fadeIn 0.3s ease-out forwards; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>,
    document.body
  );
};

export default ModalCliente;